export default __webpack_public_path__ + "static/media/tre_omini@3x.beb2f4fb.png";